var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNature = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Outdoors-Tree-Valley--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Outdoors Tree Valley Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15h-2a0.5 0.5 0 0 1 -0.5 -0.5V14a0.5 0.5 0 0 1 0.5 -0.5H23a0.48 0.48 0 0 0 0.43 -0.25 0.5 0.5 0 0 0 0 -0.5l-1.25 -2.19a0.35 0.35 0 0 1 0 -0.37 0.37 0.37 0 0 1 0.32 -0.19 0.51 0.51 0 0 0 0.44 -0.26 0.48 0.48 0 0 0 0 -0.5l-2.5 -4a0.5 0.5 0 0 0 -0.84 0l-2.5 4a0.48 0.48 0 0 0 0 0.5 0.51 0.51 0 0 0 0.44 0.26 0.37 0.37 0 0 1 0.32 0.19 0.35 0.35 0 0 1 0 0.37l-1.25 2.19a0.5 0.5 0 0 0 0 0.5 0.48 0.48 0 0 0 0.43 0.25h1.5a0.5 0.5 0 0 1 0.5 0.5v0.83a0.5 0.5 0 0 1 -0.37 0.49 14.5 14.5 0 0 0 -5.35 2.81 0.25 0.25 0 0 0 -0.09 0.24 0.24 0.24 0 0 0 0.16 0.19A12.8 12.8 0 0 1 19 22.21a2 2 0 0 1 0.46 1.28 0.5 0.5 0 0 0 0.5 0.5h3.5a0.5 0.5 0 0 0 0.5 -0.5v-8a0.5 0.5 0 0 0 -0.46 -0.49Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45 19.06a0.5 0.5 0 0 1 -0.45 -0.5V17a0.5 0.5 0 0 1 0.5 -0.5h3a1 1 0 0 0 0.82 -1.57l-2 -2.91a0.32 0.32 0 0 1 0 -0.34 0.33 0.33 0 0 1 0.29 -0.18 1 1 0 0 0 0.82 -1.5L9.17 6.4a0.51 0.51 0 0 1 0.1 -0.65 1 1 0 0 0 0.2 -1.27L6.93 0.23a0.52 0.52 0 0 0 -0.86 0L3.53 4.48a1 1 0 0 0 0.2 1.27 0.51 0.51 0 0 1 0.1 0.65L1.57 10a1 1 0 0 0 0 1 1 1 0 0 0 0.88 0.52 0.33 0.33 0 0 1 0.29 0.18 0.32 0.32 0 0 1 0 0.34l-2 2.91a1 1 0 0 0 0.82 1.57h3A0.5 0.5 0 0 1 5 17v1.74a0.5 0.5 0 0 1 -0.4 0.49 11.56 11.56 0 0 0 -4.38 1.85 0.48 0.48 0 0 0 -0.22 0.41v2a0.5 0.5 0 0 0 0.5 0.5h17a0.49 0.49 0 0 0 0.5 -0.29 0.47 0.47 0 0 0 -0.07 -0.53c-2.37 -2.78 -6.57 -3.85 -9.48 -4.11Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNature);
export default ForwardRef;